import BaseModel from "./../base/baseModel";

export default class ContaGerencialClassificacaoModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
}
